import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.assign.js";
import { getUrlParamsWithoutDecode, isObject } from './index';
/**
 * 操作埋点参数，转换为小程序的埋点格式
 * @param { String } key 需要转换的key
 * @param { String } value  需要转换的value
 * @returns  返回转换好的值
 */

var operationKey = function operationKey(key, value) {
  if (key === 'page_id' || key === 'operation_area') {
    var strValue = String(value);
    return strValue.replace(/^1/, '4');
  }

  return value;
};
/**
 * 添加公共参数到params中
 * @returns { object } 返回公共参数
 */


var getPublicParams = function getPublicParams() {
  var params = {
    channel_id: '4'
  };
  var urlParams = getUrlParamsWithoutDecode({
    // 测试代码
    // url: 'https://m.zhuanzhuan.com/zlj/zlj_tiny_mall_detail/?productId=1435900645240686593&filter=%7B%22checkOk%22%3A1%2C%22filter%22%3Afalse%2C%22hasSearchParam%22%3Afalse%2C%22isBannerActivity%22%3A0%2C%22keywordType%22%3A1%2C%22listType%22%3A1%2C%22modelMinPrice%22%3Afalse%2C%22newGroupId%22%3A70%2C%22page%22%3A1%2C%22pageSize%22%3A10%2C%22productListType%22%3A%22HOME_REC%22%2C%22sf%22%3A1%2C%22showPop%22%3Afalse%2C%22sortPolicy%22%3A0%2C%22zljDebug%22%3A0%7D&needHideHead=3&needNewWebview=1&product_info=%7B%22abtest%22%3A%22base%3Aservice_recall_0718%22%2C%22source%22%3A%22home-reco%22%2C%22md5%22%3A%22i8OgNRhGlmz0P7joouwlUQb91671s%22%7D&deviceId=30df8967976570ca81dd36f0221cac8f&openId=oHxQc0bcWnGwvTCKLoQRRuxKPtjw&deviceName=iPhone%206%2F7%2F8&system=iOS%2010.0.1&_=1ffml2b3e&__iswa=1&isWASet=1&__t=141&version=8.5.40&v=8.5.40&networkType=&token=TT%3Dc370135e1206a82096f6a93709c864e59f6fc740%26UID%3D507094314460397440%26CT%3D1631499949310%26SF%3DZHUANZHUAN%26SCT%3D1631503549310%26V%3D3%26ZLJUID%3D86457079%26ET%3D1634091949310%26AP%3D75&PPU=TT%3Dc370135e1206a82096f6a93709c864e59f6fc740%26UID%3D507094314460397440%26CT%3D1631499949310%26SF%3DZHUANZHUAN%26SCT%3D1631503549310%26V%3D3%26ZLJUID%3D86457079%26ET%3D1634091949310%26AP%3D75&uid=507094314460397440&userId=86457079&mobile=',
    decode: true
  }) || {};
  var paramsMap = {
    'zlj_user_id': 'userId',
    'open_id': 'openId',
    'zlj_device_id': 'deviceId'
  };

  for (var key in paramsMap) {
    if (urlParams[paramsMap[key]]) {
      params[key] = urlParams[paramsMap[key]];
    }
  }

  return params;
};
/**
 * 
 * @param { Obejct } data 埋点数据
 *  publicData 埋点公共参数
 *  params 埋点参数
 * @returns 
 */


function exchangeBuryPoint(data) {
  var result = data;

  try {
    result = JSON.parse(JSON.stringify(data));
  } catch (err) {
    return data;
  }

  for (var key in result) {
    var current = result[key] || {};

    if (current) {
      if (key === 'name') {
        result[key] = "h_".concat(current);
      } else {
        if (isObject(current)) {
          for (var itemKey in current) {
            current[itemKey] = operationKey(itemKey, current[itemKey]);
          }
        }
      }
    }
  }

  var _result = result,
      params = _result.params;
  Object.assign(params || {}, getPublicParams());
  result.params = params;
  return result;
}

export default exchangeBuryPoint;